import { handleActions } from 'redux-actions';
import { apiModuleDefaultState, createApiActions } from './helpers';

export const actions = createApiActions('invite');

const reducer = handleActions(
  {
    [actions.api.invite.request]: () => ({
      isFetching: true,
      isError: false,
    }),
    [actions.api.invite.response]: (_, { payload }) => ({
      isFetching: false,
      isError: false,
      data: payload,
    }),
    [actions.api.invite.error]: (_, { payload }) => ({
      isFetching: false,
      isError: true,
      error: payload,
    }),
    [actions.api.invite.setstate]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  { ...apiModuleDefaultState, data: [], error: null }
);

export default reducer;
